import axios from 'axios';

export const findCharges = (cursor, limit, success, failure) => {
    const url = "/api/v1/billing/charges";

    axios.get(url)
        .then(response => {
            const json = response.data;

            success(json);
        })
        .catch(err => {
            failure(err);
        });
};

export const findPayments = (cursor, limit, success, failure) => {
    const url = "/api/v1/billing/payments";

    axios.get(url)
        .then(response => {
            const json = response.data;

            success(json);
        })
        .catch(err => {
            failure(err);
        });
};

export const findCard = (success, failure) => {
    const url = "/api/v1/billing/card";

    axios.get(url)
        .then(response => {
            const json = response.data;
            const card = json.card || {};

            if (json.card) {
                card.id = `${json.card.type}:${json.card.last4}`;
            }

            success(card);
        })
        .catch(err => {
            failure(err);
        });
};

export const saveCard = (nonce, success, failure) => {
    const url = "/api/v1/billing/card";

    axios.put(url, {
        nonce: nonce,
    })
        .then(response => {
            const json = response.data;

            success(json.card, json.payment);
        })
        .catch(err => {
            failure(err);
        });
};

export const deleteCard = (success, failure) => {
    const url = "/api/v1/billing/card";

    axios.delete(url)
        .then(() => {
            success();
        })
        .catch(err => {
            failure(err);
        });
};

export const payNow = (chargeIds, success, failure) => {
    const url = "/api/v1/billing/chargeNow";

    axios.post(url, {
        chargeIds: chargeIds,
    })
        .then(response => {
            const json = response.data;

            success(json);
        })
        .catch(err => {
            failure(err);
        });
};
